var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.load)?_c('dashboard',{attrs:{"activeaccounts":_vm.activeAccounts,"changerequest":_vm.changeRequest,"customerrequest":_vm.customerRequest,"packagedata":_vm.packageData,"pendingapplications":_vm.pendingApplications,"networkdata":_vm.networkData,"networkspeeds":_vm.networkSpeeds,"networks":_vm.allNetworks}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }